import { createStore } from 'vuex'
import { alert } from './alert.module'
import { authentication } from './authentication.module'

const store = createStore({
  modules: {
    alert,
    authentication,
  },
})
export default store
